import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { setStaffPerms } from "../../api/platformAudit";
import { NeuButton } from "../../components/neu/Neu";
import { PermsPicker } from "./PermsPicker";

// Inline permission editor shown under each platform admin row.
export const StaffPermsRow = ({ member, reload }) => {
  const { t } = useTranslation();
  const [perms, setPerms] = useState(member.platform_perms || []);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await setStaffPerms(member.id, perms);
      toast.success(t("staff.permsSaved"));
      reload();
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 border-t border-border/50 pt-3">
      <PermsPicker value={perms} onChange={setPerms} testId={`staff-perms-${member.email}`} />
      <NeuButton
        className="px-4 py-2 text-xs"
        disabled={busy}
        data-testid={`staff-perms-save-${member.email}`}
        onClick={save}
      >
        {t("staff.savePerms")}
      </NeuButton>
    </div>
  );
};
